import './App.css';
import AnimatedCursor from "react-animated-cursor"
import React, { useState, useCallback } from 'react';
import { IoIosCodeDownload } from "react-icons/io";

const Border3 = ({ children }) => {
  return (
    <div className="border3-wrapper">
      <svg
        className="border3-svg"
        viewBox="0 0 108 108"
        preserveAspectRatio="none"
      >
        <path
          d="M7.85 4.52C10.42 4.87 12.98 4.79 15.55 4.29C18.11 3.79 20.68 3.77 23.25 4.23C25.82 4.68 28.38 4.63 30.95 4.07C33.52 3.51 36.08 3.31 38.65 3.46C41.22 3.61 43.78 3.64 46.35 3.55C48.92 3.46 51.48 3.72 54.05 4.34C56.62 4.96 59.18 5.05 61.75 4.64C64.32 4.23 66.88 3.95 69.45 3.81C72.02 3.67 74.58 3.52 77.15 3.36C79.72 3.19 82.28 3.08 84.85 3.01C87.42 2.94 89.98 3.1 92.55 3.49C95.12 3.87 97.52 4.07 99.77 4.08C102.02 4.09 103.17 5.38 103.23 7.95C103.29 10.52 103.67 13.08 104.37 15.65C105.06 18.22 105.14 20.78 104.6 23.35C104.06 25.92 103.85 28.48 103.98 31.05C104.12 33.62 103.92 36.18 103.4 38.75C102.88 41.32 102.63 43.88 102.65 46.45C102.67 49.02 102.93 51.58 103.43 54.15C103.92 56.72 104.26 59.28 104.42 61.85C104.59 64.42 104.43 66.98 103.95 69.55C103.47 72.12 103.17 74.68 103.07 77.25C102.97 79.82 103.16 82.38 103.65 84.95C104.14 87.52 104.18 90.08 103.79 92.65C103.39 95.22 103.29 97.85 103.49 100.56C103.7 103.27 102.52 104.44 99.95 104.09C97.38 103.73 94.82 103.81 92.25 104.32C89.68 104.83 87.12 104.78 84.55 104.16C81.98 103.54 79.42 103.49 76.85 104.02C74.28 104.54 71.72 104.47 69.15 103.82C66.58 103.16 64.02 102.89 61.45 103C58.88 103.11 56.32 103.44 53.75 103.99C51.18 104.54 48.62 104.52 46.05 103.93C43.48 103.35 40.92 103.09 38.35 103.14C35.78 103.2 33.22 103.59 30.65 104.29C28.08 105 25.52 104.97 22.95 104.22C20.38 103.46 17.82 103.27 15.25 103.64C12.68 104.01 10.05 104.11 7.35 103.95C4.65 103.78 3.22 102.42 3.07 99.85C2.91 97.28 3.27 94.72 4.14 92.15C5.01 89.58 5.23 87.02 4.8 84.45C4.38 81.88 4.37 79.32 4.78 76.75C5.19 74.18 5.24 71.62 5.76 69.05C6.28 66.48 6.53 63.92 6.51 61.35C6.5 58.78 6.25 56.22 5.75 53.65C5.25 51.08 4.92 48.52 4.74 45.95C4.56 43.38 4.72 40.82 5.23 38.25C5.74 35.68 5.95 33.12 5.88 30.55C5.8 27.98 6.14 25.42 6.9 22.85C7.65 20.28 7.94 17.72 7.75 15.15C7.56 12.58 7.28 10.01 7.03 7.44C6.78 4.87 7.29 4.14 7.85 4.52Z"
          fill="none"
          stroke="#4fc3f7"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
      <div className="border3-content">{children}</div>
    </div>
  );
};

const ufoKeyframes = `
  @keyframes ufo-fly {
    0%   { left: 0%; }
    100% { left: calc(100% - 48px); }
  }
  @keyframes beam-pulse {
    0%, 100% { opacity: 0.08; transform: scaleX(0.7); }
    40%, 60%  { opacity: 0.22; transform: scaleX(1); }
  }
  @keyframes ufo-shimmer {
    0%   { left: -45%; }
    100% { left: 100%; }
  }
  @keyframes ufo-blink {
    0%, 100% { opacity: 0.25; }
    50%       { opacity: 1; }
  }
`;

function UfoLoader() {
  return (
    <>
      <style>{ufoKeyframes}</style>
      <div style={{ position: 'relative', paddingTop: 48, margin: '12px 0', overflow: 'hidden' }}>
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          animation: 'ufo-fly 2s ease-in-out infinite',
        }}>
          <svg width="48" height="32" viewBox="0 0 48 32" fill="none" xmlns="http://www.w3.org/2000/svg">
            <polygon
              points="17,26 31,26 38,44 10,44"
              fill="#C4C0F8"
              style={{
                animation: 'beam-pulse 2s ease-in-out infinite',
                transformOrigin: 'top center',
              }}
            />
            <ellipse cx="24" cy="22" rx="19" ry="6.5" fill="#AFA9EC" opacity="0.3" />
            <ellipse cx="24" cy="21" rx="15" ry="5.5" fill="#7F77DD" />
            <ellipse cx="24" cy="15" rx="10" ry="9" fill="#534AB7" />
            <ellipse cx="24" cy="13.5" rx="7.5" ry="6.5" fill="#AFA9EC" opacity="0.45" />
            <circle cx="17" cy="22" r="2.2" fill="#EEEDFE"
              style={{ animation: 'ufo-blink 0.9s ease-in-out infinite' }} />
            <circle cx="24" cy="23.5" r="2.2" fill="#EEEDFE"
              style={{ animation: 'ufo-blink 0.9s ease-in-out infinite', animationDelay: '0.3s' }} />
            <circle cx="31" cy="22" r="2.2" fill="#EEEDFE"
              style={{ animation: 'ufo-blink 0.9s ease-in-out infinite', animationDelay: '0.6s' }} />
          </svg>
        </div>

        <div style={{
          height: 6,
          borderRadius: 99,
          background: 'rgba(255,255,255,0.15)',
          overflow: 'hidden',
          position: 'relative',
        }}>
          <div style={{
            position: 'absolute',
            top: 0,
            left: 0,
            height: '100%',
            width: '45%',
            borderRadius: 99,
            background: '#7F77DD',
            animation: 'ufo-shimmer 2s ease-in-out infinite',
          }} />
        </div>
      </div>
    </>
  );
}

function App() {
  const [isBoxVisible, setIsBoxVisible] = useState(true);
  const [isBioVisible, setIsBioVisible] = useState(false);

  const handleClick = useCallback(() => {
    setIsBoxVisible(false);
    setIsBioVisible(true);
  }, []);

  return (
    <>
      <div style={{ margin: '20px' }} className="App">
        <AnimatedCursor
          innerStyle={{
            backgroundColor: 'pink',
            border: '5px solid pink'
          }}
          outerStyle={{
            border: '10px solid var(--cursor-color)'
          }}
        />
        <div className="boldonse-regular">
          {isBoxVisible && (
            <div onClick={handleClick} className="wrap">
              <div className="box">
                <div>nino rex</div>
              </div>
            </div>
          )}
          <div className="content">
            <div className="postClickApp">
              {isBioVisible && (
                <Border3>
                  <div>
                    <div className="intro" style={{ marginBottom: '40px', marginTop: '20px' }}>
                      <div style={{ marginBottom: '40px' }}>
                        <i>Software Engineer &amp; Yoga Teacher</i>
                      </div>
                    </div>

                    <div>**identity loading**</div>

                    <UfoLoader />

                    <div className="resumeAndList">
                      <p>
                        <a href="https://ninorex.substack.com/">blog/substack</a>
                      </p>
                      <span style={{ marginLeft: '30px' }}>tech resume</span>{' '}
                      <a
                        className="downloadItem"
                        href="https://drive.google.com/file/d/1GO2iY2bOewc6hmmUqpP-LTg0IY1I4khu/view?usp=sharing"
                      >
                        <IoIosCodeDownload color="rgba(255, 0, 217, 0.3)" size={33} />
                      </a>
                      <br />
                    </div>
                  </div>
                </Border3>
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default App;